import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { initSentry } from './lib/sentry';
import { initPostHog } from './lib/posthog';
import { routeTree } from './routeTree.gen';

// Initialize error tracking and analytics before app renders
initSentry();
initPostHog();

// Create a new router instance
const router = createRouter({
  routeTree,
  scrollRestoration: true,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
